export default "__VITE_ASSET__DjecfVV7__"